import type {
  ApplianceConfigurationTreeItem,
  ConfigurationOptionKey,
} from '@ipfabric/utils/applianceConfiguration/ApplianceConfiguration';

export const fullConfiguration: ApplianceConfigurationTreeItem[] = [
  {
    type: 'parent',
    label: 'Device & Discovery',
    key: 'device-and-discovery',
    children: [
      {
        type: 'parent',
        label: 'Global Configuration',
        key: 'global-configuration',
        children: [
          {
            type: 'leaf',
            label: 'Device attributes',
            key: 'device-attributes',
          },
          {
            type: 'leaf',
            label: 'Jumphosts',
            key: 'jumphost',
          },
          {
            type: 'leaf',
            label: 'OUI',
            key: 'oui',
          },
        ],
      },
      {
        type: 'parent',
        label: 'Discovery settings',
        key: 'discovery-settings',
        children: [
          {
            type: 'leaf',
            label: 'Discovery',
            key: 'discovery',
          },
          {
            type: 'leaf',
            label: 'Discovery Seeds',
            key: 'discovery-seeds',
          },
          {
            type: 'leaf',
            label: 'Device Credentials',
            key: 'device-credentials',
          },
          {
            type: 'leaf',
            label: 'Assurance engine',
            key: 'assurance-engine',
          },
          {
            type: 'leaf',
            label: 'Discovery Tasks',
            key: 'discovery-tasks',
          },
          {
            type: 'leaf',
            label: 'Vendor API',
            key: 'vendors-api',
          },
          {
            type: 'leaf',
            label: 'Site Separation',
            key: 'site-separation',
          },
          {
            type: 'leaf',
            label: 'CLI settings',
            key: 'cli-settings',
          },
          {
            type: 'leaf',
            label: 'BGP Routing',
            key: 'bgp-routing',
          },
          {
            type: 'leaf',
            label: 'Manual Links',
            key: 'manual-links',
          },
          {
            type: 'leaf',
            label: 'Labels',
            key: 'labels',
          },
          {
            type: 'leaf',
            label: 'Application mapping',
            key: 'aim',
          },
        ],
      },
      {
        type: 'leaf',
        label: 'Snapshot collection',
        key: 'snapshot-retention',
      },
    ],
  },
  {
    type: 'leaf',
    label: 'Configuration management',
    key: 'configuration-management',
  },
  {
    type: 'parent',
    label: 'Integration',
    key: 'integration',
    children: [
      {
        type: 'leaf',
        label: 'API Tokens',
        key: 'api-tokens',
      },
      {
        type: 'leaf',
        label: 'Webhooks',
        key: 'webhooks',
      },
    ],
  },
  {
    type: 'parent',
    label: 'System',
    key: 'system',
    children: [
      {
        type: 'leaf',
        label: 'SNMP',
        key: 'snmp',
      },
      {
        type: 'leaf',
        label: 'Certificates & CA',
        key: 'certificates',
      },
    ],
  },
  {
    type: 'parent',
    label: 'Administration',
    key: 'administration',
    children: [
      {
        type: 'leaf',
        label: 'Local Users',
        key: 'local-users',
      },
      {
        type: 'leaf',
        label: 'LDAP',
        key: 'ldap',
      },
      {
        type: 'leaf',
        label: 'Roles',
        key: 'roles',
      },
      {
        type: 'leaf',
        label: 'Policies',
        key: 'policies',
      },
    ],
  },
  {
    type: 'leaf',
    label: 'Intent checks',
    key: 'intent-checks',
  },
  {
    type: 'leaf',
    label: 'Dashboards & Widgets',
    key: 'dashboards-and-widgets',
  },
  {
    type: 'leaf',
    label: 'Tables Data',
    key: 'table-data',
  },
  {
    type: 'leaf',
    label: 'Graph Data',
    key: 'graph-data',
  },
  {
    type: 'leaf',
    label: 'Discovery History',
    key: 'discovery-history',
  },
];

export const getLeafNodes = (
  items: ApplianceConfigurationTreeItem[],
): ConfigurationOptionKey[] => {
  const leafNodes: ConfigurationOptionKey[] = [];

  const traverse = (item: ApplianceConfigurationTreeItem) => {
    if (item.type === 'leaf') {
      leafNodes.push(item.key);
    } else {
      item.children.forEach(traverse);
    }
  };

  items.forEach(traverse);

  return leafNodes;
};
